import { render, staticRenderFns } from "./WizardTitulo.vue?vue&type=template&id=afdd1b38&"
import script from "./WizardTitulo.vue?vue&type=script&lang=js&"
export * from "./WizardTitulo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports